import Box from "@mui/material/Box"
import { createFileRoute } from "@tanstack/react-router"
import { uomLoader } from "shared/loaders"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { IncomingGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/Incoming/components"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/incoming/$goodsReceiptId/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => (
    <Box className='flex size-full flex-col'>
      <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
        <IncomingGoodsReceiptDetailsLayout />
      </PermissionContentWrapper>
    </Box>
  ),
})
